/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2019. All Rights Reserved.
 #*
 #*===================================================================
 */

import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

@Component({
  selector: 'app-profile-photo-crop-modal',
  templateUrl: './profile-photo-crop-modal.component.html',
  styleUrls: ['./profile-photo-crop-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfilePhotoCropModalComponent implements OnInit {
  imageDataUrl: string;
  imageFileName: string;
  loading: boolean;
  imageChangedEvent: any;
  croppedImage: any;
  returnUrl: string;
  showCropper = false;

  @Input() imageData: any;

  @Output() closeModal: EventEmitter<any> = new EventEmitter();

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.imageDataUrl = this.imageData.dataUrl;
    this.imageFileName = this.imageData.fileName;
    this.showCropper = true;
  }

  close() {
    this.closeModal.emit();
  }

  save() {
    this.closeModal.emit({
      file: this.croppedImage.base64,
      fileName: this.imageFileName,
    });
  }

  imageCropped(event) {
    this.croppedImage = event;
  }
}
